import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import { Box, Typography } from '@mui/material';
import Swal from 'sweetalert2';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import BrandDiv from './BrandDiv';
import { createChainedFunction, TextField } from '@mui/material';
import { Modal } from '../../../components/BootstrapToMUI';
import request from '../../../services/Request';
import { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';

export default function BrandPositionModal(props) {
  const theme = useTheme();

  const { rowData, showAdmin, data, brand, setBrand, handleSubmit, machine, setB_row, ...rest } =
    props;

  const [num, setNum] = useState();
  const [origin, setOrigin] = useState([...brand]);
  const [max, setMax] = useState(1);

  useEffect(() => {
    if (brand?.length > 0) {
      const index = num * 3;
      const newB = brand.slice(0, index);
      setOrigin(newB);
    }
  }, [num, rest.show]);

  useEffect(() => {
    const mymax = Math.ceil(brand.length / 3);

    setMax(mymax);
    if (machine?.themeColor?.b_row) {
      if (machine?.themeColor?.b_row > mymax) {
        setNum(mymax);
      } else {
        setNum(machine?.themeColor?.b_row);
      }
    } else {
      setNum(mymax);
    }
  }, [rest.show]);

  useEffect(() => {
    setOrigin([...brand]);
  }, [brand]);

  useEffect(() => {
    setB_row(num);
  }, [num]);

  const result = origin.map((prod, index) => {
    // const url = `${process.env.REACT_APP_SERVER_API}/pictures/${prod.picture}/${prod.referTo}`;
    const logo = `${process.env.REACT_APP_SERVER_API}/pictures/${prod.logo}/${prod.referTo}`;
    return (
      <Box key={index} className="brand-logo-card d-flex justify-content-center align-items-center">
        <img className="brand-logo-img" src={logo} alt=""></img>
      </Box>
    );
  });

  return (
    <Modal className="modal-w" {...rest} centered size="xl">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Arrange Your Brand Position</Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body" sx={{ textAlign: 'center' }}>
        <Container>
          <Typography variant="h5" sx={{ textAlign: 'center' }}>
            Drag and drop the list on the left to arrang your logos
          </Typography>
          <TextField
            sx={{ mt: 2.5, width: '200px' }}
            value={num}
            variant="outlined"
            onChange={(e) => {
              setNum(e.target.value);
            }}
            type="number"
            label="Show Rows"
            InputProps={{ inputProps: { min: 1, max: max } }}
          />
          <Box className="d-flex">
            <DndProvider backend={HTML5Backend}>
              <BrandDiv data={origin} setData={setOrigin} />
            </DndProvider>
            <Box className="home-brand-div">{result}</Box>
          </Box>

          <Button
            fullWidth
            onClick={() => handleSubmit()}
            variant="contained"
            color="primary"
            sx={{ mt: 3, mb: 2 }}
          >
            Submit
          </Button>
        </Container>
      </Modal.Body>
    </Modal>
  );
}
